'use strict';

var $P = require('bluebird');
$P.config({
  longStackTraces: false,
  warnings: false
});
function ScenarioKeyboardSaveService() {
  var attemptSaveWithKeyboard;
  function isReoptPreview(reoptData) {
    return !!reoptData.ndReopt || !!reoptData.mdReopt;
  }
  function attempToSave(saveData) {
    if (isReoptPreview(saveData.reoptPreviewData)) {
      if (attemptSaveWithKeyboard && attemptSaveWithKeyboard.isFulfilled && !attemptSaveWithKeyboard.isFulfilled()) {
        return $P.reject('Already done');
      }
      attemptSaveWithKeyboard = $P.delay(800).then(function () {
        return saveData;
      })["finally"](function () {
        attemptSaveWithKeyboard = null;
      });
      return attemptSaveWithKeyboard;
    }
    return $P.delay(150).then(function () {
      return saveData;
    });
  }
  return {
    attempToSave: attempToSave
  };
}
ScenarioKeyboardSaveService.$inject = [];
module.exports = ScenarioKeyboardSaveService;